import React, { forwardRef } from "react";
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import MainNavBar from "./navbar";
import timologicFooter from "../../img/timologic_login.png"
import packageJson from '../../../package.json';
import moment from 'moment';
import ChatWindow from '../chat.component';

const { version } = packageJson;


const FormTemplate = (props) => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const buildTimestamp = process.env.REACT_APP_BUILD_TIMESTAMP
        ? moment(new Date(process.env.REACT_APP_BUILD_TIMESTAMP * 1000)).format('YY.MM.DD_HH.mm')
        : moment(new Date()).format('YY.MM.DD_HH.mm');

    const showIcon = (props) => {
        if (props.icon) {
            return <span>{props.icon}</span>
        }
    }

    return (
        <div className="innerContainer">
            <MainNavBar />
            <main className="flex-shrink-0 innerContainerMain">
                <div className="container-fluid mainContainer" onClick={function () {
                    var isShown = document.getElementById("basic-navbar-nav").classList.contains("show");
                    if (isShown) {
                        document.getElementById("main-nav-toogler").click();
                    }

                }}>
                    {props.children}
                    <div className="footer navbar-fixed-bottom">
                    </div>
                </div>
            </main>
            <footer className="footer mt-auto py-3 main-footer">
                <div className="container">
                    <span className="text-muted"><img className="footerImage" src={timologicFooter}></img><small> <b>{version} </b><span style={{ fontSize: 11 }}> {buildTimestamp}</span></small></span>
                        {/* <Tippy trigger="click" content={<span className="tooltip-skin">{t("technical_support_info")}</span>}>
                                <i className="fa fa-x2 fa-info-circle infoicon phonefootericon"></i>
                            </Tippy> */}
                    <ChatWindow />
                    {/* <p  className="footermess"> <span>{t("footermess")}</span></p> */}
                </div>
            </footer>
        </div>

    );
}
export default FormTemplate

